import { fromJS } from 'immutable';

export const initialState = fromJS({
    isLoading: false,
    usageLog: {
        availableUsagePeriods: [],
        facilityUsagesGroups: []
    }
});